import React from "react"

export enum EmbededVideoType {
    VERTICAL = "VERTICAL",
    HORIZONTAL = "HORIZONTAL",
    EXTERNAL = "EXTERNAL",
}
const getVideoWidth = (videoType: EmbededVideoType) => {
    switch(videoType) {
        case EmbededVideoType.VERTICAL:
            return "450"
        default:
            return "950"
    }
}
const getVideoHeight = (videoType: EmbededVideoType) => {
    switch(videoType) {
        case EmbededVideoType.VERTICAL:
            return "550"
        default:
            return "500"
    }
}

const Video = ({ videoSrcURL, videoTitle, videoType, ...props }) => (
  <div className="video">
    <iframe
      src={videoSrcURL}
      title={videoTitle}
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      width={getVideoWidth(videoType)}
      height={getVideoHeight(videoType)}
    />
  </div>
)
export default Video